import React from 'react';
import { useTranslation } from 'react-i18next';
import LoyaltyTokenContainer from '@alphapoint/apex-web/lib/components/LoyaltyToken/LoyaltyTokenContainer';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './LoyaltyTokenPage.css';

const loyaltyTokenPageClasses = getBEMClasses('loyalty-token-page');

const LoyaltyTokenPage = () => {
  const { t } = useTranslation();

  return (
    <div className={loyaltyTokenPageClasses()}>
      <h1 className={loyaltyTokenPageClasses('header')}>{t('Loyalty Token')}</h1>
      <p className={loyaltyTokenPageClasses('description')}>
        {t(
          'Using LTC for transaction fees applies a discount to your trading fee. If you hold LTC in your account, you have the option of having your trading fees automatically subtracted from your LTC balance.',
        )}
      </p>
      <LoyaltyTokenContainer />
    </div>
  );
};

export default LoyaltyTokenPage;
